<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<label for="">Seleccione clientes</label>
				<treeselect 
					:multiple="true"
    				:options="ListaClientes"
    				placeholder="Activos"
    				v-model="ListaClientesSelect">
				</treeselect>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'Clientes',
	props:["poBtnSave"],
	data() {
		return {
			Modal:true,
			FormName:'clientes',
			IdUsuario:0,
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ListaClientes:[],
			ListaClientesSelect:[],
		}
	},
	methods: {
		async GetListaClientes(){
			await this.$http.get('sucursalproveedor/get',{
				params:{
					RegEstatus:'A'
				}
			}).then((res)=>{
				this.ListaClientes=res.data.data.todos.map((value) => {
					return {
						id:value.IdSucursal,
						label:value.Nombre
					}
				});
			})
		},
		async Guardar(){
			let formData=new FormData();
			formData.set('IdUsuario',this.IdUsuario);
			formData.append('Clientes',JSON.stringify(this.ListaClientesSelect));
			await this.$http.post('sucursalxdistribuidor/post',formData).then((res)=>{
				this.poBtnSave.disableBtn = false;
				this.poBtnSave.toast = 1;
				$('#cliente').modal('hide');
			});
		},
		Recuperar(){
			this.$http.get('sucursalxdistribuidor/recovery',{
				params:{
					IdUsuario:this.IdUsuario
				}
			}).then((res)=>{
				this.ListaClientesSelect=res.data.data.clientesselect;
			})
		}
	},
	created() {
		this.bus.$off('NewModal_'+this.EmitSeccion);
		this.bus.$on('NewModal_'+this.EmitSeccion,(IdUsuario)=>{
			this.IdUsuario=IdUsuario;
			this.GetListaClientes();
			this.Recuperar();
			this.bus.$off('Save_'+this.EmitSeccion);
			this.bus.$on('Save_'+this.EmitSeccion,()=>{
				this.Guardar();
			});
		});
	},
}
</script>

<style>

</style>
